var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"woocommerce-button button ad_button",class:{ 'ad_button--loading' : _vm.loading },attrs:{"disabled":_vm.loading}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }